<template>
  <div>
    <v-menu
      v-model="menu"
      bottom
      absolute
      :position-y="65"
      :max-width="340"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          icon
          class="mr-2 header-user-button"
          v-on="on"
        >
          <bkf-avatar :user="user" />
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <bkf-avatar :user="user" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title> {{ user.firstname }} {{ user.lastname }}</v-list-item-title>
              <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider />
        <v-list
          nav
          class="pa-0"
        >
          <v-list-item class="mb-0">
            <v-list-item-content class="pa-0">
              <v-btn
                text
                class="normal-text"
                @click.native="$refs.profileSettings.open()"
              >
                {{ 'v2.fm2.settings.profile-settings'|trans }}
              </v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item class="mb-0">
            <v-list-item-content class="pa-0">
              <v-btn
                text
                class="normal-text"
                @click.native="$refs.companySettings.open()"
              >
                {{ 'v2.fm2.settings.company-settings'|trans }}
              </v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item
            class="mb-0"
          >
            <v-list-item-content class="pa-0">
              <v-btn
                text
                class="normal-text"
                @click="$emit('guide')"
              >
                {{ 'profile.guide'|trans }}
              </v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <template v-if="user.extras.impersonate">
            <v-list-item
              class="mb-0"
            >
              <v-list-item-content
                class="pa-0"
              >
                <v-btn
                  text
                  class="normal-text"
                  @click.native="$refs.impersonate.impersonate()"
                >
                  {{ 'v2.fm2.profile.impersonate'|trans }}
                </v-btn>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list-item
              class="mb-0"
            >
              <v-list-item-content
                class="pa-0"
              >
                <v-list-item-subtitle class="text-caption text-center">
                  {{ 'v2.fm2.application.version'|trans }} {{ version }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
          </template>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            tile
            @click.native="logout"
          >
            {{ 'v2.i2m_users.login.logout'|trans }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <Impersonate
      v-if="user.extras.impersonate"
      ref="impersonate"
    />
    <UserSettings ref="profileSettings" />
    <CompanySettings ref="companySettings" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import oauth from '@services/oauth';
import Impersonate from './Impersonate';
import UserSettings from './UserSettings';
import CompanySettings from './CompanySettings';

export default {
  components: {
    Impersonate,
    UserSettings,
    CompanySettings,
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    ...mapGetters({
      config: 'config',
      user: 'users/current',
    }),
    version: () => VERSION,
  },
  methods: {
    async logout() {
      oauth.logout();
      await this.$sleep(300);

      window.location = '#/login';
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="stylus" src="./ProfileMenu.styl"></style>
